import React, { Component } from "react";
import MetisMenu from "metismenujs";
import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
  verify_admin,
  resetLoginState,
  getGeneral,
} from "../../store/actions";
import withRouter from "../Common/withRouter";
import { hasAnyPermission, hasPermission } from "./Permission";
import LoadingDialog from "../../components/Common/LoadingDialog";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pathName: this.props.router.location.pathname,
    };
  }

  componentDidMount() {
    this.initMenu();
    // this.props.verify_admin();
    this.props.getGeneral();
  }
  componentDidUpdate(prevProps) {
    if (this.props.router.location.pathname !== prevProps.router.location.pathname) {
      // this.props.getGeneral();
    }
  }

  UNSAFE_componentDidUpdate(prevProps) {

    if (prevProps !== this.props) {

      if (this.props.type !== prevProps.type) {
        this.initMenu();
      }

    }
    if (this.props.router.location.pathname !== prevProps.router.location.pathname) {

      this.setState({ pathName: this.props.router.location.pathname }, () => {

        this.initMenu();
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");
  }

  checkPathIncludes = (item, isSubmenu = false) => {
    const path = this.props.router.location.pathname;
    const pathParts = path.split('/');
    let currentSidebarItem = item;
    let indicator = false;
    if (currentSidebarItem.submenu && !isSubmenu) {
      for (let i = 0; i < currentSidebarItem.submenu.length; i++) {
        if (currentSidebarItem.submenu[i].route.includes(path)) {
          indicator = true;
        } 
      }
      if (item.label === 'Products' && (pathParts.includes('edit-product') || pathParts.includes('add-product') || pathParts.includes('inventory'))) {
        indicator = true;
      } else if (item.label === 'Marketing' && (pathParts.includes('edit-voucher') || pathParts.includes('add-voucher') || pathParts.includes('edit-promo-code') || pathParts.includes('add-promo-code') || pathParts.includes('add-banner') || pathParts.includes('edit-banner'))) {
        indicator = true;
      } else if (item.label === 'Reporting' && (pathParts.includes('sales-report') || pathParts.includes('sales-by-product-report') || pathParts.includes('sales-by-category-report') || pathParts.includes('customer-report') || pathParts.includes('marketing-report'))) {
        indicator = true;
      }

      if (item.label === 'Reporting' && pathParts[pathParts.length - 1] === 'customer') {
        indicator = false;
      }
    } else {
      if (item.label === 'Orders' && (pathParts.includes('view-order') || pathParts.includes('add-order'))) {
        indicator = true;
      } else if (item.label === 'Customers' && (pathParts.includes('edit-customer') || pathParts.includes('add-customer'))) {
        indicator = true;
      } else if (item.label === 'Support' && (pathParts.includes('view-inquiry'))) {
        indicator = true;
      } else if (item.label === 'Reviews' && (pathParts.includes('view-review'))) {
        indicator = true;
      } else if (item.label === 'Banners' && (pathParts.includes('add-banner') || pathParts.includes('edit-banner'))) {
        indicator = true;
      } else if (item.label === 'All products' && (pathParts.includes('add-product') || pathParts.includes('edit-product'))) {
        indicator = true;
      } else if (item.label === 'Inventories' && (pathParts.includes('inventory'))) {
        indicator = true;
      } else {
        const cleanPath = pathParts[pathParts.length - 1];
        const cleanStr = item?.route.replace(/[-\/]/g, '');
        const routeParts = item?.route.split('/');
        const lastPart = routeParts[routeParts.length - 1];
        indicator = cleanPath.includes(lastPart);
      }

      if (item.label === 'Customers' && pathParts[pathParts.length - 1] === 'customer-report') {
        indicator = false;
      }
    }
    return indicator;

  };



  render() {
    const permissions = (this.props.verifyAdmin && this.props.verifyAdmin.user && this.props.verifyAdmin.user.data && this.props.verifyAdmin.user.data.permissions) || [];
    const sidebarItems = [
      {
        label: "OPERATIONS",
        isTitle: true,
      },
      {
        label: "Dashboard",
        icon: "ri-home-3-line",
        route: "/dashboard",
      },
      {
        label: "Orders",
        icon: "ri-shopping-cart-2-line",
        route: "/order",
        permission: "view-order",
        notification: this.props.order_number,
      },
      {
        label: "Products",
        icon: "ri-price-tag-3-line",
        route: "#",
        permission: ["view-product", "view-inventory"],
        submenu: [
          {
            label: "All products",
            route: "/product-listing",
            permission: "view-product",
          },
          {
            label: "Inventories",
            route: "/inventory",
            permission: "view-inventory",
          },
        ],
      },
      {
        label: "Customers",
        icon: "ri-team-line",
        route: "/customer",
        permission: ["view-customer", "create-customer"],
      },
      {
        label: "Marketing",
        icon: "ri-megaphone-line",
        route: "#",
        permission: ["view-marketing", "create-marketing"],
        submenu: [
          {
            label: "Vouchers",
            route: "/voucher",
            permission: "view-marketing",
          },
          {
            label: "Promo Codes",
            route: "/promo-code",
            permission: "view-marketing",
          },
          {
            label: "Banners",
            route: "/banners",
            permission: "view-marketing",
          },
        ],
      },
      {
        label: "Reviews",
        icon: "ri-chat-4-line",
        route: "/review",
        permission: ["view-review"],
        notification: this.props.review_number,
      },
      {
        label: "ADMINISTRATIVE",
        isTitle: true,
      },
      {
        label: "Settings",
        icon: "ri-settings-5-line",
        route: "/settings",
        permission: ["view-setting"],
      },
      {
        label: "Reporting",
        icon: "ri-line-chart-line",
        route: "#",
        permission: ["view-reporting"],
        submenu: [
          {
            label: "Sales Report",
            route: "/sales-report",
            permission: "view-reporting",
          },
          {
            label: "Sales by Product",
            route: "/sales-by-product-report",
            permission: "view-reporting",
          },
          {
            label: "Sales by Category",
            route: "/sales-by-category-report",
            permission: "view-reporting",
          },
          {
            label: "Customer Report",
            route: "/customer-report",
            permission: "view-reporting",
          },
          {
            label: "Marketing Report",
            route: "/marketing-report",
            permission: "view-reporting",
          },
        ],
      },
      {
        label: "Support",
        icon: "ri-customer-service-2-fill",
        route: "/support",
        permission: ["view-support"],
      },
    ];
    return (
      <React.Fragment>
        <div id="sidebar-menu">
          <LoadingDialog open={!sidebarItems} />
          <ul className="metismenu list-unstyled" id="side-menu">
            {
              sidebarItems.map((item, index) => (
                <li key={index}>
                  {
                    // item.permission &&
                    item.link ?
                      <a href={`/`} target="_blank" rel="noreferrer" alt="download"
                        className={item.submenu ? "waves-effect" : this.checkPathIncludes(item) ? "route-selected waves-effect" : "waves-effect"}
                        style={{
                          display: item.permission ? (hasAnyPermission(permissions, item.permission) ? "" : "none") : "",
                        }}>
                        <i className={item.icon} style={{ color: this.checkPathIncludes(item) && '#000000' }}></i>
                        <span className="ms-1">{item.label}</span>
                      </a>
                      :
                      item.isTitle ?
                        <div className="menu-title">{item.label}</div>
                        :
                        <Link
                          to={item.route}
                          className={this.checkPathIncludes(item) ? "route-selected waves-effect" : "waves-effect"}
                          style={{
                            display: item.permission ? (hasAnyPermission(permissions, item.permission) ? "" : "none") : "",
                            marginInline: '10px'
                          }}>
                          <i className={item.icon} style={{ color: this.checkPathIncludes(item) && '#000000' }}></i>
                          <span className="ms-1">{item.label} </span>
                          {
                            // item?.notification &&
                            <span className="badge float-end" style={{ paddingRight: "0px", marginTop: -1, color: '#A0A0A0', fontSize: 14, fontFamily: 'Manrope-SemiBold' }}>
                              {item.notification}
                            </span>
                          }
                        </Link>
                    // :
                    // item.isTitle ?
                    //   <div className="menu-title">{item.label}</div>
                    //   :
                    //   <Link to={item.route} className={item.submenu ? "has-arrow waves-effect" : "waves-effect"} style={{ color: this.props.router.location.pathname === item.route && '#cfdbe4' }}>
                    //     <i className={item.icon} style={{ color: this.props.router.location.pathname === item.route && '#cfdbe4' }}></i>
                    //     <span className="ms-1">{item.label}</span>
                    //   </Link>
                  }

                  {item.submenu && (
                    <ul className="sub-menu">
                      {item.submenu.map((subItem, subIndex) => (
                        hasPermission(permissions, subItem.permission) &&
                        <li
                          key={subIndex}
                        // className={this.checkPathIncludes(subItem.route) && "subroute-selected"}
                        >
                          <Link to={subItem.route} style={{ color: this.checkPathIncludes(subItem, true) ? '#ED1A3D' : '#8590a5', fontSize: 15 }} >
                            {subItem.label} {subItem.notification !== undefined && subItem.notification !== null && subItem.notification !== "" && <span className="badge bg-primary-yellow float-end" style={{ paddingLeft: "8px", paddingRight: "8px" }}>{subItem.notification}</span>}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))
            }
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
    verifyAdmin: state.Login.verifyAdmin,
    order_number: state.General.order_number,
    review_number: state.General.review_number,
  };
};

export default withRouter(connect(mapStateToProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeLayoutWidth,
  changePreloader,
  verify_admin,
  resetLoginState,
  getGeneral
})(withTranslation()(SidebarContent)));
